module.exports = __webpack_public_path__ + "static/media/close_icon_black.a2400e2d.svg";